/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <path
    fill="currentColor"
    fillRule="evenodd"
    d="M23.1664 8.401a.9965.9965 0 0 0 .6598-.4252c.311-.4588.1931-1.084-.2633-1.3966L11.9999 0 .4369 6.5792l-.116.0926c-.3582.3323-.43.887-.1473 1.304l.0922.1166a.9961.9961 0 0 0 .5675.3085.9925.9925 0 0 0 .7298-.1604l.7702-.4297v12.5036l.0067.2245C2.4555 22.4699 4.05 24 6 24h11.9999l.2233-.0067c1.9211-.1161 3.4433-1.7188 3.4433-3.6789l-.0001-12.5023.7704.4284.1282.0746a.9923.9923 0 0 0 .6014.0858ZM5.8296 21.981c-.8404-.0858-1.4963-.7992-1.4963-1.6666V6.6984l7.6666-4.2665 7.6665 4.2665.0001 13.616-.0086.1713c-.0853.8448-.7951 1.504-1.658 1.504h-12l-.1703-.0087Zm9.9769-10.835c.3905-.3925.3905-1.029 0-1.4215-1.9526-1.9627-5.1184-1.9627-7.071 0-1.9526 1.9627-1.9526 5.1448 0 7.1076 1.9526 1.9627 5.1184 1.9627 7.071 0 .3905-.3926.3905-1.029 0-1.4216a.9964.9964 0 0 0-1.4142 0c-1.1716 1.1777-3.071 1.1777-4.2426 0-1.1716-1.1776-1.1716-3.0869 0-4.2645s3.071-1.1776 4.2426 0a.9964.9964 0 0 0 1.4142 0Z"
    clipRule="evenodd"
  />,
  'MenuHome'
);
